import styled from 'styled-components';
export const CustomPageHtml = styled.div`
  margin: 30px;
`;
